// extracted by mini-css-extract-plugin
export default {"clientSecret":"ServiceAccountNewClientSecret_clientSecret__eJXJC","button":"ServiceAccountNewClientSecret_button__VJrUy"};